import React from 'react';
import { Flex, Box, flameTheme } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';
import { IconChevronLeft } from '@lightspeed/flame/Icon/ChevronLeft';
import { IconDesktop } from '@lightspeed/flame/Icon/Desktop';

interface ModalHeaderContentProps {
  showDeviceConnection: boolean;
  handleClick: () => void;
}
const ModalHeaderContent: React.FC<ModalHeaderContentProps> = ({
  showDeviceConnection,
  handleClick,
}) => {
  const { colors, fontSizes } = flameTheme;
  return (
    <>
      <Box mt={3}>
        <IconDesktop size={fontSizes['text-xl']} />
      </Box>
      <Text mt={2}>Connect Customer Facing Display</Text>
      {showDeviceConnection ? (
        <Flex mt={2} mb={2} alignItems="center">
          <IconChevronLeft baseColor={colors['blue-500']} />
          <TextLink size="small" style={{ fontWeight: 100 }} onClick={handleClick}>
            Back
          </TextLink>
        </Flex>
      ) : (
        <Text mt={2} mb={2} size="small" style={{ fontWeight: 100 }} color={colors.textDimmed}>
          Choose a connection method
        </Text>
      )}
    </>
  );
};

export { ModalHeaderContent };
